import { render, staticRenderFns } from "./PermissionSettings.vue?vue&type=template&id=20724be5"
import script from "./PermissionSettings.vue?vue&type=script&lang=js"
export * from "./PermissionSettings.vue?vue&type=script&lang=js"
import style0 from "./PermissionSettings.vue?vue&type=style&index=0&id=20724be5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports